import { Box, Dialog, styled, Typography } from "@mui/material";

export const Row = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const FormRow = styled(Row)`
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const HelperCaption = styled(Typography)`
  margin-inline-start: ${({ theme }) => theme.spacing(2)};
  margin-top: -12px;
`;

export const FieldGroup = styled(Box)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const StyledDialog = styled(Dialog)``;

export const DialogContentWrapper = styled(Box)`
  display: flex;
  gap: 28px;
  justify-content: center;
  margin-block: 16px;
`;

export const OptionBoxWrapper = styled(Box)`
  width: 200px;
  height: 220px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.divider};
    transform: scale(1.1);
  }
`;

export const OptionBoxTitle = styled(Typography)`
  min-height: 20%;
  max-height: 20%;
`;

export const OptionBoxImage = styled("img")`
  width: 80%;
  aspect-ratio: 1/1;
`;

export const DrawerWrapper = styled(Box)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
